import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IS_JEST, DEV_MODE } from '../../utils/Constants';
import From from '../../components/controls/Form';
import Button from '../../components/controls/Button';
import { TextParagraph } from '../../components/controls/Typography/TextBody';
import Heading from '../../components/controls/Typography/Heading';

import './RetrievePassword.less';

const RetrievePassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { email = '' } = location.state || {};

  useEffect(() => {
    document.title = 'Letters Portal - Retrieve Password';
    IS_JEST || DEV_MODE || email ? void 0 : navigate('/notFound');
  }, []);

  return (
    <main className="lsn-page lsn-page-password-reset-link-sent container">
      <Heading className="no-focus-outline text-center" tabIndex={0} aria-label={`Letters portal by Liaison Retrieve Password`}>
        Retrieve Password
      </Heading>
      <From
        title='Check your inbox!'
        isNarrow
        hasBorder
        isButtonsStack
        formAttr={{
          title: 'Retrieve Password'
        }}
        buttons={<Button onClick={() => navigate('/login')} primary type='button'>
          Back to Login
        </Button>
        }
      >
        <TextParagraph>
          Steps on how to access your account will be emailed to you if your email address <strong>{email}</strong> is registered.
        </TextParagraph>
      </From>
    </main>
  );
};

export default RetrievePassword;
